import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { SystemSettings } from '@/types/system';
import { systemService } from '@/services/systemService';

interface SystemState {
  settings: SystemSettings | null;
  loading: boolean;
}

const initialState: SystemState = {
  settings: null,
  loading: false,
};

export const fetchSettings = createAsyncThunk(
  'system/fetchSettings',
  async () => {
    const response = await systemService.getSettings();
    return response;
  }
);

export const updateSettings = createAsyncThunk(
  'system/updateSettings',
  async (settings: Partial<SystemSettings>) => {
    const response = await systemService.updateSettings(settings);
    return response;
  }
);

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchSettings.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.settings = action.payload;
      });
  },
});

export default systemSlice.reducer;
